import { Link, createFileRoute } from "@tanstack/react-router";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_app/stealth-ai-writer/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] w-full flex-col rounded-xl border bg-white p-4 text-black dark:bg-black dark:text-white">
      <div className="h-[100%] w-full overflow-hidden border-gray-200 p-6 dark:border-gray-800">
        <header className="mb-20 flex w-full items-center justify-between">
          <div>
            <h1 className="text-xl font-medium">Stealth AI</h1>
            <p className="text-sm text-muted-foreground">
              Create or enhance content with real-time AI.
            </p>
          </div>
        </header>

        <main className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center gap-8">
            <div className="relative">
              <div className="absolute -z-10 size-20 rounded-full bg-pink-100 blur-md dark:bg-pink-900/30" />
              <img
                src="/icons/stealth.svg"
                alt="Stealth AI Logo"
                className="relative z-10 h-auto w-50"
              />
            </div>

            <div className="flex flex-col items-center justify-center text-center">
              <h2 className="mb-1 text-xl font-medium">Stealth AI</h2>
              <p className="text-sm text-muted-foreground">
                Create or enhance content with real-time AI.
              </p>
            </div>

            <Link
              className={cn(
                buttonVariants(),
                "w-64 bg-pink-600 hover:bg-pink-700 dark:bg-pink-600 dark:text-white dark:hover:bg-pink-700",
              )}
              to="/stealth-ai-writer/generate-article"
            >
              Start New
            </Link>
          </div>
        </main>
      </div>
    </div>
  );
}
